module.exports = "/img/2.ab53f6.webp";